import React from 'react'

const Error = ({ err }) => <div>{err}</div>

export default Error
